import { createStore } from '@orderx/lab/xr/store';
import uniq from 'lodash/uniq';
import { AppCache } from '../services/app-cache';
import { Order } from '../XV2';
import { utilLog } from '../util/utilLog';
import { OrderProduct } from '../XV2';
import { useCallback } from 'react';
import { useXV1 } from '../useXV1';
import { XV1 } from '../XV1';

type UserOrder = Pick<Order, 'id' | 'status' | 'sequence' | 'userId'>;

type UserOrderExtended = UserOrder & {
    orderProducts: UserOrderProduct[];
    image?: string;
};

type UserOrderProduct = Pick<OrderProduct, 'id' | 'status' | 'orderId'>;

const { useStore } = createStore(AppCache.get('orderIdsCached') || []);
const storeOrderGuids = createStore<string[]>(AppCache.get('orderGuids') || []);
const { useStore: useIsBubblesVisible } = createStore<boolean>(true);
const { useStore: useOrders } = createStore<UserOrderExtended[]>([]);

export function useCustomerOrders() {
    const [, setOrderGuids] = storeOrderGuids.useStore();
    const [orderIdsCached, setOrderIdsCached] = useStore();
    const [orders, setOrders] = useOrders();
    const [isBubblesVisible, setIsBubblesVisible] = useIsBubblesVisible();
    const getOrders = useXV1(XV1.API.MeOrderPost, { onSuccess: setOrders });

    const loadOrders = useCallback(() => {
        getOrders.run({
            orderIds: orderIdsCached,
            orderGuids: AppCache.get('orderGuids') || [],
        });
    }, [orderIdsCached]);

    return {
        orders: orders,
        loadOrders: loadOrders,
        cacheOrderId(id: number) {
            const next = uniq([...orderIdsCached, id]);
            setOrderIdsCached(next);
            AppCache.set('orderIdsCached', next);
        },
        isBubblesVisible,
        setIsBubblesVisible,
        cacheOrderGuid(guid: string) {
            utilLog('useCustomerOrders.cacheOrderGuid', guid);

            setOrderGuids((guids) => {
                if (!guids.includes(guid)) {
                    guids.push(guid);
                }

                AppCache.set('orderGuids', guids);
            });
        },
    };
}
